import {BrowserStorage} from "../storage/BrowserStorage";

// eslint-disable-next-line camelcase
declare const c_FlashSaleDataPath: string;

export type FlashsaleType = {
  endDate: string;
  path: string;
  blogCTAImg?: string;
  blogCTAImg2x?: string;
  banner?: string;
  headline?: string;
  mediaId?: string;
  imgAltText?: string;
  swiperMobileImage?: string;
  swiperDesktopImage?: string;
};

export type LoadFlashsalesMethodType = () => Promise<FlashsaleType[]>;

const sessionStorageKey = "c_FlashsaleData";

const browserStorage = new BrowserStorage<FlashsaleType[]>({
  type: "sessionStorage",
  dataIdentifier: sessionStorageKey,
  hoursToCache: 24,
});

// Lade Flashsales
export async function loadFlashsales(): Promise<FlashsaleType[]> {
  // Zuerst in der Localstorage nach Daten suchen und verarbeiten
  let flashsalesFromStorage: FlashsaleType[] | null;
  try {
    flashsalesFromStorage = browserStorage.read(sessionStorageKey);
  } catch (e) {
    browserStorage.remove(sessionStorageKey);
    flashsalesFromStorage = await loadFlashsales();
  }

  if (flashsalesFromStorage !== null) {
    return flashsalesFromStorage;
  } else {
    // Falls nicht vorhanden, Daten vom FlashSaleDataPath holen und zwischenspeichern
    const fetchData = await fetch(c_FlashSaleDataPath);
    const fetchString = await fetchData.text();
    const parsedAndFiltered = filterFlashsalesFromDocument(new DOMParser().parseFromString(fetchString, "text/xml"));
    browserStorage.write(sessionStorageKey, parsedAndFiltered);

    return parsedAndFiltered;
  }
}

function filterFlashsalesFromDocument(data: Document): FlashsaleType[] {
  const flashsaleElements = data.getElementsByTagName("FlashSale");
  const now = Date.now();

  return Array.from(flashsaleElements)
    .filter((flashsale) => {
      const endDateText = flashsale.getElementsByTagName("EndDate")[0]?.textContent;
      const pathText = flashsale.getElementsByTagName("Path")[0]?.textContent;

      if (!(endDateText && pathText)) {
        return false;
      }

      return Date.parse(endDateText) > now;
    })
    .map((elem): FlashsaleType => {
      const text = (selector: string): string | undefined => {
        return elem.getElementsByTagName(selector)[0]?.textContent?.trim() ?? undefined;
      };

      return {
        endDate: text("EndDate") ?? "",
        path: text("Path") ?? "",
        blogCTAImg: text("BlogCTAImg"),
        blogCTAImg2x: text("BlogCTAImg2x"),
        banner: text("Banner"),
        headline: text("Headline"),
        mediaId: text("MediaId"),
        imgAltText: text("ImgAltText"),
        swiperMobileImage: text("SwiperMobileImage"),
        swiperDesktopImage: text("SwiperDesktopImage"),
      };
    });
}
